import React, { useContext, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { contextApiActions } from "../../../_redux/_constants";
import { Context } from "../../../_context/Store";
import { hideAjaxSuccess } from "../../../_redux/_actions";

export default function UiSuccessAlertBox() {
     const [state, dispatch] = useContext(Context);

     const actionDispatch = useDispatch();

     const handleCancel = () => {
          dispatch({
               type: contextApiActions.UI_SUCCESS_MESSAGE_TOGGEL,
               payload: { show: false },
          });

          actionDispatch(hideAjaxSuccess());
     };

     const { successMessage, loading } = useSelector((state) => {
          return {
               successMessage: state.successMessage,
               loading: state.loading,
          };
     });

     useEffect(
          function () {
               if (successMessage.show) {
                    handleShow(successMessage.messages);
               }
          },
          [successMessage],
     );

     useEffect(function () {
          setTimeout(() => {
               handleCancel();
          }, 12000);
     }, []);

     const handleShow = (messages) => {
          dispatch({
               type: contextApiActions.UI_SUCCESS_MESSAGE_TOGGEL,
               payload: { show: true, messages },
          });
     };

     return (
          <>
               {state.uiSuccessMessageDetails.show && (
                    <div className="sb-top-success-alert-box">
                         <Alert
                              variant="filled"
                              severity="success"
                              onClose={() => handleCancel()}
                         >
                              {state.uiSuccessMessageDetails.messages.map(
                                   (message, index) => (
                                        <p key={index}>{message}</p>
                                   ),
                              )}
                         </Alert>
                    </div>
               )}
          </>
     );
}
